import { useRequest } from "hooks";
import type { ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { TransactionTrackingDeliveryCodesResponse } from "../types";
import { getTransactionTrackingDeliveryCodesThunk } from "../thunks";
import {
    changeExportTransactionTrackingDeliveryCodesLoading as changeExportLoading
} from "../slice";

export const useTransactionTrackingDeliveryCodesActions = () => {
    const getTransactionTrackingDeliveryCodes = useRequest<
        ThunkReturnType<TransactionTrackingDeliveryCodesResponse>,
        string | undefined
    >({
        thunk: getTransactionTrackingDeliveryCodesThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetTransactionTrackingDeliveryCodes
    });

    return {
        getTransactionTrackingDeliveryCodes,
        downloadCsv
    };
};

export default useTransactionTrackingDeliveryCodesActions;
